export const defaultDataModal = {
  open: false,
  title: 'Defaul title',
  description: 'Defaul description',
  type: '', // update, add, delete, message, error, crawl
  data: null,
  id: null,
}
